"use client";

import * as React from "react";
// @ts-ignore - TypeScript has issues with Radix UI exports
const LabelPrimitive = require("@radix-ui/react-label");

import { cn } from "lib/utils";

// Explicitly include `htmlFor` in the props to ensure TS accepts it even if the underlying
// Radix type definition changes across versions.
interface ExtraLabelProps {
  htmlFor?: string;
  className?: string;
  children?: React.ReactNode;
}

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & ExtraLabelProps
>(({ className, children, ...props }, ref) => {
  return (
    <LabelPrimitive.Root
      ref={ref}
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
    </LabelPrimitive.Root>
  );
});

Label.displayName = LabelPrimitive.Root.displayName || "Label";

export { Label };
